import { Client } from '@bugsnag/core'
import { isServer } from '@/utils/app/detect'

const initBugsnagClient = () => {
  return isServer() ? require('./bugsnag.server').default : require('./bugsnag.client').default
}

/**
 * Get bugsnag client instance.
 *
 * @see https://docs.bugsnag.com/platforms/javascript/react/
 *
 * @returns Bugsnag client
 */
export const getBugsnagClient = (): Client | undefined => {
  const init = initBugsnagClient()
  return init()
}

/**
 * Notify bugsnag with an error.
 * @param message The breadcrumb message
 * @param metadata All additional data to send with the error
 */
export const notifyError = (message: any, metadata?: Record<string, any>): void => {
  const client = getBugsnagClient()
  if (client) {
    client?.notify(message, (event) => {
      if (metadata) {
        event.addMetadata('meta', metadata)
      }
    })
  } else {
    console.error(message, metadata)
  }
}

/**
 * Add breadcrumb to bugsnag history.
 * @param message The breadcrumb message
 * @param metadata All additional data to send with the breadcrumb
 */
export const leaveBreadcrumb = (message: string, metadata?: Record<string, any>): void => {
  const client = getBugsnagClient()
  client?.leaveBreadcrumb(message, metadata)
}
